// ============================================================
// Matrix Builder Utility
// ============================================================
import { GAP_TYPES } from '../data/gapKeywords';
import { buildLimitationsMatrix, aggregateGapScores } from './gapDetectionEngine';

/**
 * Returns full matrix data object ready for rendering.
 */
export function buildFullMatrix(processedArticles = []) {
  const matrixRows = buildLimitationsMatrix(processedArticles);
  const rankedGaps = aggregateGapScores(processedArticles);

  // Gap type frequency map
  const typeCounts = {};
  Object.keys(GAP_TYPES).forEach((t) => (typeCounts[t] = 0));
  processedArticles.forEach((a) => {
    if (a.dominantGapType) typeCounts[a.dominantGapType]++;
  });

  return { matrixRows, rankedGaps, typeCounts };
}

/**
 * Radar chart data format for Recharts.
 */
export function buildRadarData(rankedGaps = []) {
  const maxScore = rankedGaps.length > 0
    ? Math.max(...rankedGaps.map((x) => x.totalScore))
    : 10;
  const fullMark = maxScore + 2;
  return rankedGaps.map((g) => ({
    subject: g.label.replace(' Gap', ''),
    score: g.totalScore,
    articles: g.articleCount,
    fullMark,
  }));
}

/**
 * Horizontal bar chart data format for Recharts.
 */
export function buildBarData(rankedGaps = []) {
  return rankedGaps.map((g) => ({
    name: g.label.replace(' Gap', ''),
    score: g.totalScore,
    articles: g.articleCount,
    percentage: g.percentage,
    color: g.color,
  }));
}
